<template>
  <van-row type="flex" justify="space-between" class="header-title">
    <img class="title-logo" src="http://image.ahsjgs.com/images/default/logo-new.png" alt="" @click="homeClick"/>
    <van-popover v-model="showPopover" trigger="click" :actions="list" @select="onSelect"
                 placement="bottom-end">
      <template #reference>
        <div style="text-align: center;width: 50px">
          <img class="title-menu" src="@/assets/ic_menu.png" alt=""/>
        </div>
      </template>
    </van-popover>
  </van-row>
</template>

<script>
export default {
  name: "headerTitle",
  data() {
    return {
      showPopover: false,
      menuList: [],//首页menu数据
      list: []
    };
  },
  mounted() {
    this.menuList = this.$utils.getLocal("menuList");
    this.menuList.forEach(item => {
      this.list.push({text: item.menuName})
    })
  },
  methods: {
    homeClick() {
      this.$router.replace({path: "/home"});
    },
    onSelect(action, index) {
      this.$router.push({path: this.menuList[index].menuUrl});
    },
  },
}
</script>

<style lang="less" scoped>
.header-title {
  padding: 12px 20px;
  background: white;

  .title-logo {
    height: 25px;
    object-fit: contain;
    margin: auto 0;
  }

  .title-menu {
    width: 15px;
    height: 15px;
    padding: 5px;
  }
}
</style>
